import React from 'react';
import PropTypes from 'prop-types';
import BodyMarkersDefault from './bodyMarkersDefault';
import './clickPopUp.scss';

function ClickModalPopUp({ detalhes }) {
  return (
    <div id="click-popUp">
      <BodyMarkersDefault detalhes={detalhes} />
    </div>
  );
}

ClickModalPopUp.propTypes = {
  detalhes: PropTypes.shape().isRequired,
};

export default ClickModalPopUp;
